<template>
    <div>
        <base-header class="pb-6 pb-8 pt-6 pt-md-6" type="gray-100">
          
        </base-header>

            <template v-if="loading">
                <div class="m-2">
                <skeleton altura="400px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                </div>
            </template>

        <div class="container-fluid mt--7" v-if="!loading">
            <div class="row">
                <div class="col-12 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">Dentista Externo</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-8">
                                            <base-input alternative=""
                                                label="Nome Completo"
                                                input-classes="form-control-alternative"
                                                v-model="model.nome"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-12 col-lg-3">
                                            <base-input alternative=""
                                                label="CPF"
                                                input-classes="form-control-alternative"
                                                v-model="model.cpf"
                                                mask="###.###.###-##"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-2 col-12">
                                            <base-input alternative=""
                                                label="CRO"
                                                input-classes="form-control-alternative"
                                                v-model="model.cro"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-2 col-12">
                                            <base-input alternative=""
                                                label="CRO UF"
                                                input-classes="form-control-alternative"
                                                v-model="model.croUf"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-2 col-12">
                                            <base-input alternative=""
                                                label="Telefone"
                                                input-classes="form-control-alternative"
                                                v-model="model.telefone"
                                                mask="(##) ####-####"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-2 col-12">
                                            <base-input alternative=""
                                                label="Celular"
                                                input-classes="form-control-alternative"
                                                v-model="model.celular"
                                                mask="(##) #####-####"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6 col-12">
                                            <base-input alternative=""
                                                label="E-mail"
                                                input-classes="form-control-alternative"
                                                v-model="model.email"
                                                        
                                            />
                                        </div>
                                    </div>
                                </div>

                                <input type="hidden" v-model="model.lab_id">

                                <hr class="my-4" />

                                 <div class="pl-lg-4 text-right">

                                 <template v-if="loading2">
                                    <div class="m-2">
                                    <skeleton altura="100px" :velocidade="2.2" :atraso="0.2" :itens="1" classItem="mb-2"></skeleton>
                                    </div>
                                </template>

                                <div v-if="!loading2" style="display: flex; justify-content: space-between">
                                    <base-button
                                    type="danger"
                                    @click="excluir()"
                                    v-html="txt2"
                                ></base-button>

                                <base-button
                                    type="default"
                                    @click="salvar()"
                                    v-html="txt1"
                                    ></base-button>
                                </div>
                            </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import dentista from '@/cflow/dentistaexterno.js'
//import agenda from '@/cflow/agendaProtetica.js'
  //import parametros from "@/cflow/parametros.js";
  //import BaseButton from '../../components/BaseButton.vue';
  //import BaseInput from '../../components/BaseInput.vue';
  //import Multiselect from "vue-multiselect";

    import router from '@/router'
import "vue-select/dist/vue-select.css";
  export default {
    name: 'tables',
    components: {
     // Multiselect,
      //BaseInput,
    },
    
    methods: {
        salvar: function() {

            this.loading = true;
            const _this = this;
            const _id = this.$route.params.id || '0';
            const form = this.model;

            dentista.salvar(_id, form).then(() => {
                _this.loading = false;
                router.push('/dentistas-externos');
                
            }).catch((err) => {
                console.err('ERROR', err);
                _this.loading = false;
                _this.hasError = true;
                 setTimeout(function(){
                    _this.hasError = false;
                },5000);
            });

           
        },

        excluir: function() {

            this.loading = true;
            const _this = this;
            const _id = this.$route.params.id || '0';

            alert('Todos os dados como ordens e procedimentos deste dentista serão excluídos.');

            dentista.delete(_id).then(() => {
                _this.loading = false;
                router.push('/dentistas-externos');
                
            }).catch((err) => {
                console.err('ERROR', err);
                _this.loading = false;
                _this.hasError = true;
                setTimeout(function(){
                    _this.hasError = false;
                },5000);
            });


            },

        detalhes: function(_id) {
            this.loading = true; 
            const _this = this;

            dentista.detalhes(_id).then(res => {
                _this.model = res;
                this.model.lab_id = res.id_lab;
                this.loading = false;
            }).catch((error) => {
                console.err('ERROR', error);
            });
        }
    },
    data() {
      return {
        txt1: 'Salvar',
        txt2: 'Excluir',
        tipo: null,
        id: null,
        status: [{'nome': 'Aguardando', 'valor': 'aguardando'}, {'nome': 'Em Produção', 'valor': 'producao'}, {'nome': 'Finalizado', 'valor': 'finalizado'}],
        hasSuccess: false,
        hasError: false,
        loading: false,
        loading2: false,
        dated: '',
        model: {
          descritivo: '',
          quant: '',
          min_quant: '',
          lab_id: 0
        }
      }
    },

     mounted(){

        const _id = this.$route.params.id || '';
        if(_id) this.detalhes(_id)

        
      

    }
  };
</script>
<style>
.height, .ProseMirror {
    min-height: 300px;
}
.select {
    width: 100%;
    padding: 5px 5px;
}
</style>
